import React, { Component } from 'react';
import AppsEmDestaqueItem from './AppsEmDestaqueItem';

import '../css/AppsEmDestaque.css';

class AppsEmDestaque extends Component {
  constructor(){
    super();
    this.state = {
      apps : [],
    };

  }

  componentWillReceiveProps(props) {
    this.setState({apps : props.apps, lang : props.lang});
  }

  render() {
    return (
        <section id="appsEmDestaque">
          {this.state.apps.map(app => <AppsEmDestaqueItem app={app} key={app.id} />)}
        </section>
    );
  }
}

export default AppsEmDestaque;



// WEBPACK FOOTER //
// ./src/componentes/AppsEmDestaque.js